import { ErrorPageLayout } from '@/components/features/Errors/ErrorPageLayout';
import { Button } from '@/components/ui/shadcn/button';
import { useTranslations } from '@/hooks/useTranslations';
import { Head, Link } from '@inertiajs/react';
import { KeyRound } from 'lucide-react';

export default function Unauthorized() {
    const { t } = useTranslations();

    return (
        <>
            <Head title={t('errors.unauthorized.title', 'Sign in required')} />
            <ErrorPageLayout
                icon={<KeyRound />}
                tone="warning"
                code={t('errors.unauthorized.code', '401')}
                title={t('errors.unauthorized.title', 'Sign in required')}
                description={t('errors.unauthorized.description', 'You need to sign in to access this page.')}
                actions={
                    <Button asChild>
                        <Link href="/login">{t('errors.unauthorized.sign_in', 'Sign in')}</Link>
                    </Button>
                }
            />
        </>
    );
}
